import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Card } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import Loader from 'react-js-loader'
import loader from '../loder.gif'
import CryptoJS from 'crypto-js';
import withReactContent from "sweetalert2-react-content";
import playSound from "./accept.mp3";
import Swal from 'sweetalert2'
import admindata from '../../components/admindata'
import { apiRequest } from '../../store/allApi'

import { dateFormat } from '../../utils/dateTime'
const $ = require('jquery')
$.Datatable = require('datatables.net')

const WithdrawVerify = () => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const [loading, setLoading] = useState(false)
  const [user, setUser] = useState()
  const [manualPayment, setManualPayment] = useState()
  const [mount, setMount] = useState(false)
  const [disable, setDisable] = useState(false)

  const isToday = (dateString) => {
    return dateString > "2025-11-17T00:00:00.888Z";
  };

  const profile = async() => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
     try {
          const res = await apiRequest(`admin/withdraw/all/pending`,"GET", null,headers)
         if (res.data) {
              setUser(res?.data)
      $('table').dataTable()
         }
            } catch (e) {
             console.log(e)
            }
            finally {
            }
  }

  const permission1 = localStorage.getItem("PData");
  const pdata = JSON.parse(permission1);
  const meedata = localStorage.getItem("uData");
  const userData = JSON.parse(meedata);
  const MySwal = withReactContent(Swal);
    const SiteData = localStorage.getItem("siteSetting");
  const Setting = JSON.parse(SiteData);

  const verifyWithdraw = async (id, accountNumber, ifscCode, name,amount,type,upi,qrImage) => {
    const result = await Swal.fire({
      title: 'Select Payment Method',
      // input: 'radio',
      html: type === "upi" 
        ? `<h4 style="font-weight: 900;">${name}</h4>
           <h4 style="font-weight: 900;">Upi : <span class="copy-text">${upi}</span>
           <button class="copy-btn btn-success" data-text="${upi}" style="margin-left:10px; padding:5px 10px; font-size:12px; cursor:pointer;">Copy</button>
           </h4>
           <h4 style="font-weight: 900;">₹<span class="copy-text">${amount}</span>
           <button class="copy-btn btn-success" data-text="${amount}" style="margin-left:10px; padding:5px 10px; font-size:12px; cursor:pointer;">Copy</button>
           
           </h4>
           <button class="copy-btn btn-success" data-text="${upi} ${name} ${amount}" style="margin-right:256px; padding:5px 10px; font-size:12px; cursor:pointer;">Copy</button>

           `
  : type === "qrcode"
  ? `
      <h4 style="font-weight: 900;">${name}</h4>
      <h4 style="font-weight: 900;">Scan QR Code:</h4>
      <img src="${baseUrl+qrImage}" alt="QR Code" style="width:200px;height:200px;display:block;margin:10px auto;border:2px solid #000;border-radius:10px;"/>
      <h4 style="font-weight: 900;">₹<span class="copy-text">${amount}</span>
      <button class="copy-btn btn-success" data-text="${amount}" style="margin-left:10px; padding:5px 10px; font-size:12px; cursor:pointer;">Copy</button>
      </h4>
    `
  : `
                   <h4 style="font-weight: 900;">
                   <span class="copy-text">
                   <button class="copy-btn btn-success" data-text="${accountNumber}\n${ifscCode}\n${name}\n${amount}" style="margin-right:26px; padding:5px 10px; font-size:12px; cursor:pointer;">Copy</button>
                   
                   </span>
                   <span class="copy-text">${accountNumber}</span>
           <button class="copy-btn btn-success" data-text="${accountNumber}" style="margin-left:10px; padding:5px 10px; font-size:12px; cursor:pointer;">Copy</button></h4>
                  <h4 style="font-weight: 900;"><span class="copy-text">${ifscCode}</span>
           <button class="copy-btn btn-success" data-text="${ifscCode}" style="margin-left:10px; padding:5px 10px; font-size:12px; cursor:pointer;">Copy</button></h4>
        <h4 style="font-weight: 900;"> <span class="copy-text">${name}</span>
           <button class="copy-btn btn-success" data-text="${name}" style="margin-left:10px; padding:5px 10px; font-size:12px; cursor:pointer;">Copy</button>
        </h4>

    
           <h4 style="font-weight: 900;">₹<span class="copy-text">${amount}</span>
           <button class="copy-btn btn-success" data-text="${amount}" style="margin-left:10px; padding:5px 10px; font-size:12px; cursor:pointer;">Copy</button>
           
           </h4>


           </h4>
           <h4 style="font-weight: 90; font-size:8px;"><span class="copy-text">${accountNumber}@${ifscCode}.ifsc.npci</span>
           <button class="copy-btn btn-success" data-text="${accountNumber}@${ifscCode}.ifsc.npci" style="margin-left:10px; padding:5px 10px; font-size:12px; cursor:pointer;">Copy</button>
           
           </h4>
            


           <div id="custom-toast" style="display:none; position:fixed; bottom:20px; right:20px; background:green; color:white; padding:10px; border-radius:5px;">Copied!</div>
           `,
           showCancelButton: true,
           confirmButtonText: 'Verify',
           cancelButtonText: 'Cancel',
     didOpen: () => {
           const swalContainer = Swal.getHtmlContainer(); 
           if (swalContainer) {
             swalContainer.querySelectorAll(".copy-btn").forEach(button => {
               button.addEventListener("click", async (event) => {
                 event.stopPropagation(); // Prevents the modal from closing
                 const textToCopy = event.currentTarget.getAttribute("data-text");
   
                 try {
                   await navigator.clipboard.writeText(textToCopy);
                   // ✅ Show native toast notification 
                   const toast = document.getElementById("custom-toast");
                   toast.style.display = "block";
                   setTimeout(() => {
                     toast.style.display = "none";
                   }, 1500);
                 } catch (err) {
                   console.error("Copy failed:", err);
                   // alert("Copy failed! Please try again.");
                    navigator.clipboard.writeText(textToCopy);
                   // ✅ Show native toast notification 
                   const toast = document.getElementById("custom-toast");
                   toast.style.display = "block";
                   setTimeout(() => {
                     toast.style.display = "none";
                   }, 1500);
                 }
               });
             });
           }
         }
    });
  
    if (result.isConfirmed) {
      const access_token = localStorage.getItem('token');
      const headers = {
        Authorization: `Bearer ${access_token}`
      };
  
      try {
        const res = await apiRequest(`admin/withdraw-verified/` + id, "GET", null, headers);
        if (res.data) {
          Swal.fire({
            title: "Verify success",
            text: res.data.msg,
            icon: "success",
          });
          profile();
        }
      } catch (e) {
        if (e.response?.status === 401) {
          window.location.reload();
        }
      }
    }
  };

  const reject = async id => {
       setMount(true)
       const access_token = localStorage.getItem('token')
       const headers = {
         Authorization: `Bearer ${access_token}`
       }
     
       const { value: manualPaymentInput } = await Swal.fire({
            title: 'Enter Reject Payment Details',
            input: 'text',
            inputPlaceholder: 'Enter Reject Msg here',
            showCancelButton: true,
            inputValidator: (value) => {
              if (!value) {
                return 'Payment details cannot be empty!';
              }
              return null; // Valid input
            },
          });
     
       if (manualPaymentInput) {
         
          try {
               const res = await apiRequest(`withdraw/reject/${id}`,"PATCH", {status: 'reject', msg: manualPaymentInput},headers)
              if (res.data) {
                   setMount(false)
             if (res.data.error) {
               Swal.fire({
                 title: res.data.message,
                 icon: 'error', // Changed 'danger' to 'error'
                 confirmButtonText: 'OK'
               })
             }
             profile()
              }
                 } catch (e) {
                         setMount(false)
             profile()
                 }
                 finally {
                 }
       } else {
         setMount(false)
       }
     }

useEffect(() => {
    profile()
    const interval = setInterval(() => {
      profile()
    }, 4000)
    return () => clearInterval(interval)
  }, [])

  if (user == undefined) {
    return null
  }

  

  return loading ? (
    <>
      <div className='App'>
        <div className='item dashboaed_loader'>
          <Loader
            type='bubble-ping'
            bgColor={'#fff'}
            title={<img src={loader} alt='Loading...' />}
            color={'#000'}
            size={100}
          />
        </div>
      </div>
    </>
  ) : (
    <>
      <div className='row mt-5'>
        <div className='col-12 grid-margin'>
          <div className='card'>
            <div className='card-body table_bg'>
              <h4 className='dashboard_heading'> Withdrawl verify</h4>
              <div className='table-responsive'>
                <table className='table'>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th> ID</th>
                      <th> Phone no.</th>
                      <th> Username</th>
                      <th> Amount </th>
                      <th> Withdraw type </th>
                      <th> Withdraw Req.. Time </th>
                      <th> Action </th>
                    </tr>
                  </thead>

                  <tbody>
                    {user &&
                     user?.filter(item => item.withdrawVerified === false).map((item, index) => (
                        
                        <tr key={item._id}>
                          <audio src={playSound} autoPlay></audio>
                          <td>{index + 1}</td>
                          <td>{item._id}</td>

                          {userData.user_type == 'Admin'  ? (
                            <td>{item.User_id?.Phone}</td>
                          ) : (
                            <td>{`${
                              '********' + item.User_id?.Phone.toString().slice(-2)
                            }`}</td>
                          )}

                          <td>
                            {item.User_id && (
                              <Link
                                className='btn btn-sm btn-outline-info'
                                to={`/user/view_user/${item.User_id._id}`}
                              >
                                  {
                                  item.User_id?.Red_zone == true ?
                                <span className="text-danger">
                                {item.User_id.Name}
                                </span>
                                :
                                 item.User_id?.totalDeposit < Setting?.newUserDeposit && isToday(item.User_id?.createdAt) ?
                                <span className="text-success">
                                {item.User_id.Name}
                                </span>
                                :
                                <span>
                                {item.User_id.Name}
                                </span>
}
                              </Link>
                            )}
                          </td>
                          <td>{item.amount}</td>
                          <td>{item.Withdraw_type}</td>
                          <td>{dateFormat(item.createdAt)}</td>
                          <td>
                            {item.status == 'Pending' && (
                              <>
                                {item.withdrawVerified == false ? (
                                    <button
                                      className="btn btn-success mr-2"
                                      onClick={() =>
                                        verifyWithdraw(
                                          item?._id,
                                          item?.User_id?.account_number,
                                          item?.User_id?.ifsc_code,
                                          item?.User_id?.holder_name,
                                          item?.amount,
                                          item?.Withdraw_type,
                                          item?.User_id?.upi_id,
                                          item?.paymentImage,
                                        )
                                      }
                                    >
                                      Verify
                                    </button>
                                  ) : 
                                ""  }                              
              
                                <button
                                  className='btn btn-danger mr-2'
                                  onClick={() => reject(item._id)}
                                >
                                  reject
                                </button>
                              </>
                            )}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default WithdrawVerify
